"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageTemplateSpinner = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const StyledDiv = (0, styled_components_1.default)(core_1.Box) `
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`;
const PageTemplateSpinner = (_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (react_1.default.createElement(StyledDiv, Object.assign({ className: `page-template-spinner${className ? ` ${className}` : ''}` }, props),
        react_1.default.createElement(core_1.CircularProgress, { className: 'circular-progress' })));
};
exports.PageTemplateSpinner = PageTemplateSpinner;
exports.default = exports.PageTemplateSpinner;
//# sourceMappingURL=PageTemplateSpinner.js.map